<template>
	<div class="pt-2">
		<v-dialog v-model="dialog" max-width="70vw">
			<v-card>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md6>
								<v-text-field
									v-model="editedItem.startDate"
									label="Start Date"
								></v-text-field>
							</v-flex>
							<v-flex xs12 sm6 md6>
								<v-text-field
									v-model="editedItem.endDate"
									label="End Date"
								></v-text-field>
							</v-flex>
						</v-layout>
						<v-layout
							wrap
							v-for="(item, index) in editedItem.targets"
							:key="index"
						>
							<v-flex xs12 sm6 md6>
								<v-text-field
									v-model="item.target"
									:label="`Target ${index + 1}`"
								></v-text-field>
							</v-flex>
							<v-flex xs11 sm5 md5>
								<v-text-field
									v-model="item.reward"
									:label="`Reward ${index + 1}`"
								></v-text-field>
							</v-flex>
							<v-flex>
								<v-icon
									v-if="index !== 0"
									small
									@click="editedItem.targets.splice(index, 1)"
								>
									delete
								</v-icon>
							</v-flex>
						</v-layout>
						<v-layout justify-center>
							<v-icon small class="mr-2" @click="addItem()">
								add
							</v-icon></v-layout
						>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" flat @click="close"
						>Cancel</v-btn
					>
					<v-btn color="blue darken-1" flat @click="save">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<div class="mx-2">
			<v-select
				:items="appTypes"
				v-model="selectedAppType"
				label="App Type"
				outline
				:color="themeInputColor"
				@change="updateAppType"
			></v-select>
		</div>
		<v-data-table
			:headers="headers"
			:items="tsmTargetGmvData"
			:items-per-page="5"
			class="elevation-1"
		>
			<template v-slot:items="props">
				<tr>
					<td
						v-for="item in fixedHeaders"
						:key="item.value"
						class="text-xs-center"
					>
						{{ props.item[item.value] }}
					</td>
					<td
						v-for="(item, index) in props.item.targets"
						:key="`target-${index}`"
						class="text-xs-center"
					>
						{{ item.target }}
					</td>
					<td
						v-for="(item, index) in props.item.targets"
						:key="`reward-${index}`"
						class="text-xs-center"
					>
						{{ item.reward }}
					</td>
					<td class="justify-center layout px-1">
						<v-icon
							small
							class="mr-2"
							@click="editItem(props.item)"
						>
							edit
						</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
		<label class="pa-2" for="files">Upload a CSV formatted file: </label>
		<v-layout class="pa-3" align-center>
			<v-flex xs6 sm4 md4>
				<input
					ref="inputUpload"
					type="file"
					@change="onFileChange"
					accept=".csv"
					required
					class="input"
				/> </v-flex
			><v-flex xs2 sm1 md1>
				<v-icon class="cancel-icon" @click="clearInput">
					{{ "cancel" }}
				</v-icon>
			</v-flex>
			<v-flex xs4 sm7 md7>
				<v-btn
					depressed
					color="primary"
					class="upload-btn"
					@click="uploadFile()"
					:disabled="!isFileSelected"
				>
					Upload
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout align-center justify-center>
			<div class="mt-3">
				<a target="_blank" :href="sampleCsv">Download sample file</a>
			</div>
		</v-layout>
		<div v-if="loading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
	</div>
</template>

<script>
import {
	FETCH_ALL_TSM_TARGETS,
	UPDATE_TSM_TARGETS,
	SHOW_ALERT,
	UPLOAD_MEDIA_TO_SERVER,
	UPDATE_TSM_CSV_FILEPATH
} from "@/store/action-types";
import { mapState } from "vuex";
import { JEET_11_CDN_BASE_LINK } from "@/store/config";
let filePayload = null;

export default {
	name: "AddUpdateTSMTarget",
	props: ["title", "themeInputColor", "appType"],
	data() {
		return {
			sampleCsv: `${JEET_11_CDN_BASE_LINK}/sample-csv/tsmTargetsSample.csv`,
			tsmTargetGmvData: [{ targets: [], startDate: "NA", endDate: "NA" }],
			dialog: false,
			maxTargetLength: 0,
			isFileSelected: false,
			loading: false,
			uploadKey: "tsmTargetAdmin",
			fixedHeaders: [],
			headers: [],
			editedIndex: -1,
			editedItem: {
				startDate: "",
				endDate: ""
			},
			defaultItem: {
				startDate: "",
				endDate: ""
			},
			selectedAppType: "JEET11",
			appTypes: ["JEET11", "RUMMY"]
		};
	},
	mounted() {
		this.fetchTSMTargetGmvData();
	},
	computed: {
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			alert: state => state.common.alert
		})
	},
	methods: {
		updateAppType() {
			this.fetchTSMTargetGmvData();
		},
		fetchTSMTargetGmvData() {
			this.loading = true;
			this.$store
				.dispatch(FETCH_ALL_TSM_TARGETS.dispatch, {
					appType: this.selectedAppType
				})
				.then(resp => {
					this.updateHeaderAndData(resp);
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.loading = false;
				});
		},
		updateTSMTargetGmvData(updatedItem) {
			this.loading = true;
			this.$store
				.dispatch(UPDATE_TSM_TARGETS.dispatch, {
					appType: this.selectedAppType,
					...updatedItem,
					targets: JSON.stringify(updatedItem.targets)
				})
				.then(() => {
					this.tsmTargetGmvData[this.editedIndex] = {
						...updatedItem
					};
					this.updateHeaderAndData(this.tsmTargetGmvData);
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.loading = false;
				});
		},
		updateHeaderAndData(resp) {
			this.tsmTargetGmvData = resp;
			this.maxTargetLength = resp.reduce((acc, curr) => {
				return Math.max(acc, curr.targets.length);
			}, 0);
			this.tsmTargetGmvData = this.tsmTargetGmvData.map(item => {
				const fillValueLength =
					this.maxTargetLength - item.targets.length;
				return {
					...item,
					targets: [
						...item.targets,
						...Array(fillValueLength).fill({
							target: "NA",
							reward: "NA"
						})
					]
				};
			});
			this.fixedHeaders = [];
			Object.keys(resp[0] || {}).forEach(header => {
				if (
					header !== "createdOn" &&
					header !== "updatedOn" &&
					header !== "targets"
				) {
					this.fixedHeaders.push({
						text: header,
						value: header,
						align: "center",
						sortable: false
					});
				}
			});
			this.headers = [
				...this.fixedHeaders,
				...Array.from(Array(this.maxTargetLength).keys()).map(
					(item, index) => {
						return {
							text: `Target ${index + 1}`,
							value: `target`,
							align: "center",
							sortable: false
						};
					}
				),
				...Array.from(Array(this.maxTargetLength).keys()).map(
					(item, index) => {
						return {
							text: `Reward ${index + 1}`,
							value: `reward`,
							align: "center",
							sortable: false
						};
					}
				)
			];
		},
		uploadFile() {
			this.clearInput();
			this.$store
				.dispatch(UPLOAD_MEDIA_TO_SERVER.dispatch, {
					key: this.uploadKey,
					file: filePayload,
					type: "csvUpload"
				})
				.then(data => {
					this.uploadFilePath(data.fileUrl);
				})
				.catch(err => console.log(err));
		},
		uploadFilePath(filePath) {
			this.$store
				.dispatch(UPDATE_TSM_CSV_FILEPATH.dispatch, {
					appType: this.selectedAppType,
					filePath
				})
				.then(() => {
					this.fetchTSMTargetGmvData();
				})
				.catch(err => console.log(err));
		},
		editItem(item) {
			this.editedIndex = this.tsmTargetGmvData.indexOf(item);
			this.editedItem = JSON.parse(JSON.stringify(item));

			this.dialog = true;
		},
		addItem() {
			this.editedItem.targets.push({ target: "NA", reward: "NA" });
		},
		close() {
			this.dialog = false;
			setTimeout(() => {
				this.editedItem = { ...this.defaultItem };
				this.editedIndex = -1;
			}, 300);
		},
		save() {
			const updatedItem = { ...this.editedItem };
			updatedItem.targets = updatedItem.targets.filter(item => {
				return item.target !== "NA" ? true : false;
			});
			this.updateTSMTargetGmvData(updatedItem);
			this.close();
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.isFileSelected = true;
			filePayload = files[0];
		},
		clearInput() {
			this.$refs.inputUpload.value = "";
			this.isFileSelected = false;
		},
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		}
	},
	watch: {
		dialog(val) {
			val || this.close();
		}
	}
};
</script>

<style lang="scss" scoped>
.overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
}
</style>
